import { data_room as ddcDataRoom } from "ddc";
import { MediaDataRoomOrganizationPermission } from "features/dataRoomCreation/models";
import { RawMatchingID } from "models";

export type MediaDataRoomPublishingStep = "pending" | "completed";

export const matchingIdToFormatTypeAndHashingAlgorithmMap: Record<
  RawMatchingID,
  [ddcDataRoom.FormatType, ddcDataRoom.HashingAlgorithm | null]
> = {
  [RawMatchingID.HASHED_EMAIL]: [
    ddcDataRoom.FormatType.Email,
    ddcDataRoom.HashingAlgorithm.Sha256Hex,
  ],
  [RawMatchingID.EMAIL]: [ddcDataRoom.FormatType.Email, null],
  [RawMatchingID.HASHED_PHONE_NUMBER]: [
    ddcDataRoom.FormatType.PhoneNumberE164,
    ddcDataRoom.HashingAlgorithm.Sha256Hex,
  ],
  [RawMatchingID.PHONE_NUMBER]: [ddcDataRoom.FormatType.PhoneNumberE164, null],
  [RawMatchingID.STRING]: [ddcDataRoom.FormatType.String, null],
};

export const mediaDataRoomOrganizationPermissionToPermissionMap: Record<
  MediaDataRoomOrganizationPermission,
  ddcDataRoom.Permission
> = {
  [MediaDataRoomOrganizationPermission.VIEW_OVERLAP]:
    ddcDataRoom.Permission.ViewOverlap,
  [MediaDataRoomOrganizationPermission.VIEW_INSIGHTS]:
    ddcDataRoom.Permission.ViewInsights,
  [MediaDataRoomOrganizationPermission.PROVIDE_SEED_AUDIENCE]:
    ddcDataRoom.Permission.ProvideSeedAudience,
  [MediaDataRoomOrganizationPermission.PROVIDE_BASE_AUDIENCE]:
    ddcDataRoom.Permission.ProvideBaseAudience,
  [MediaDataRoomOrganizationPermission.CAN_CREATE_AUDIENCES]:
    ddcDataRoom.Permission.CreateCustomAudience,
  [MediaDataRoomOrganizationPermission.CAN_EXPORT_AUDIENCES]:
    ddcDataRoom.Permission.ExportAudience,
};
